import { render, staticRenderFns } from "./previewTabDialog.vue?vue&type=template&id=d96cf400&"
import script from "./previewTabDialog.vue?vue&type=script&lang=js&"
export * from "./previewTabDialog.vue?vue&type=script&lang=js&"
import style0 from "./previewTabDialog.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports